import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const PENDING_INVITE_REDIRECT_KEY = 'pendingInviteRedirect';

/**
 * Mounted in GuestRoutes for the dashboard invitation URL:
 *   /dashboard/:userId/invitation/:code/:key
 *
 * Persists the post-auth destination and immediately forwards the guest
 * to InviteSignupPage with the raw invite params in the URL.
 * InviteSignupPage owns the verifyInvitation call and handles both
 * the "new user → register" and "existing user → sign in" cases itself.
 */
export default function GuestInvitationRedirect() {
  const navigate = useNavigate();
  const { userId, code, key } = useParams<{ userId: string; code: string; key: string }>();

  useEffect(() => {
    localStorage.setItem(
      PENDING_INVITE_REDIRECT_KEY,
      JSON.stringify({ path: '/profile', state: { tab: 'dashboard', view: 'invitations' } })
    );

    navigate(`/invite-signup/${userId}/${code}/${key}`, { replace: true });
  }, [navigate, userId, code, key]);

  return null;
}
